module.exports = __webpack_public_path__ + "img/Overlay (3).ca8d50c7.png";